<template>
  <van-popup
      v-model="showPopup"
      position="bottom"
      round
      :close-on-click-overlay="true"
      @click-overlay="closePopup"
  >
    <!-- 弹出内容（保持原有DOM结构） -->
    <div class="popup-content">
      <div class="popup-header">
        <h3 class="popup-title">公告</h3>
        <span class="close-btn" @click="closePopup">×</span>
      </div>
      <div class="popup-body">
        <textarea
            v-model="announcement"
            placeholder="请输入公告内容..."
            class="textarea"
        ></textarea>
      </div>
      <div class="popup-footer">
        <button class="publish-btn" @click="handlePublish">发布</button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant';
import { mapGetters } from "vuex";

export default {
  name: 'NoticePopup',
  components: {
    [Popup.name]: Popup
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["live"]),
    showPopup: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  data() {
    return {
      announcement: ''
    };
  },
  methods: {
    closePopup() {
      this.showPopup = false;
    },
    handlePublish() {
      if (!this.announcement.trim()) {
        this.$toast('公告内容不能为空！');
        return;
      }
      this.$http.post('/chat/publicNotice', {liveId: this.live.id, announcement: this.announcement})
          .then(() => {
            this.announcement = '';
            this.$Bus.$emit("refreshNotice");
            this.$Bus.$emit("refreshMsg");
            this.$toast.success('发布成功！');
          })
      this.closePopup();
    }
  }
};
</script>

<style lang="less" scoped>
/* 变量定义（保持原有rem计算方式） */
@rem: 75px;
@green: #07C160;

.custom-popup {
  /* 覆盖Vant默认样式 */
  .van-popup {
    width: 10rem; /* 750px / 75 */
    max-height: 8rem; /* 600px / 75 */
    border-radius: 0.2133rem 0.2133rem 0 0; /* 16px / 75 */
  }
}

/* 以下样式完全保持原样 */
.popup-content {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.popup-header {
  padding: 0.2667rem; /* 20px / 75 */
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.popup-title {
  font-size: 0.48rem; /* 36px / 75 */
  margin: 0;
}

.close-btn {
  font-size: 0.4267rem; /* 32px / 75 */
  color: #999;
  cursor: pointer;
}

.textarea {
  width: 100%;
  height: 2.6667rem; /* 200px / 75 */
  padding: 0.2667rem; /* 20px / 75 */
  font-size: 0.3733rem; /* 28px / 75 */
  border: 1px solid #eee;
  border-radius: 0.1067rem; /* 8px / 75 */
  resize: none;
  flex: 1;
}

.popup-footer {
  padding: 0.2667rem; /* 20px / 75 */
  text-align: right;
}

.publish-btn {
  background: @green;
  color: white;
  border: none;
  border-radius: 0.2667rem; /* 20px / 75 */
  padding: 0.1067rem 0.32rem; /* 8px 24px / 75 */
  font-size: 0.3733rem; /* 28px / 75 */
  cursor: pointer;
}

/* 动画（通过Vant内置） */
/* iOS安全区域（Vant已自动处理） */
</style>
